// A counterparty's credit assessment on its profile (TX-US-0027). Risk fills the sheet in and
// saves it against the version read; everyone else reads what was answered.

import { getCreditAssessment, saveCreditAssessment } from '../../api.js';
import SheetPanel from '../sheets/SheetPanel.jsx';
import * as kit from './sheet.js';

const COPY = {
  heading: 'Credit assessment',
  preparedBy: 'Prepared by',
  save: 'Save assessment',
  saved: 'Credit assessment saved.',
  coreKind: 'approval_core_missing',
  keeps: 'A counterparty Risk has passed keeps its',
  stale: 'This assessment changed since you opened it. Reload to see the current version.',
};

export default function CreditAssessment({ counterpartyId, canEdit, onSaved }) {
  return (
    <SheetPanel id="credit-assessment" counterpartyId={counterpartyId} canEdit={canEdit}
                onSaved={onSaved} load={getCreditAssessment} save={saveCreditAssessment}
                kit={kit} copy={COPY} />
  );
}
